import { CallsStats } from '@/types';

export interface CallsStatsPerDay extends CallsStats {
    date: string;
    averageDuration: number;
    averageTimeAvailable?: number;
    averageTotalIdleTime?: number;
    averageIdleTime?: number;
}
